import { Heading, HeadingProps } from "@chakra-ui/react";

type TinyHeadingProps = HeadingProps;

const TinyHeading = (props: TinyHeadingProps) => (
  <Heading
    fontSize="xs"
    fontWeight="semibold"
    lineHeight="3"
    opacity="0.8"
    textTransform="uppercase"
    {...props}
  />
);

export default TinyHeading;
